import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import useSeo from "@/hooks/useSeo";

export default function BookingCancel() {
  useSeo({ title: "Deposit Cancelled | Full Indoor Air Services" });
  return (
    <div className="bg-bone min-h-[70vh] section-pad" data-testid="booking-cancel-page">
      <div className="max-w-2xl mx-auto text-center">
        <div className="inline-flex w-16 h-16 rounded-full bg-clay/15 text-clay items-center justify-center mb-6">
          <AlertCircle size={28} />
        </div>
        <h1 className="font-heading text-4xl tracking-tighter font-light">Deposit not collected.</h1>
        <p className="text-muted2 mt-4 max-w-md mx-auto">
          Don't worry — your booking is still saved. A team member will reach out to confirm by phone.
          You can also retry adding a deposit anytime.
        </p>
        <div className="mt-10 flex gap-3 justify-center">
          <Link to="/" className="btn-ghost">Back to home</Link>
          <Link to="/book" className="btn-primary" data-testid="cancel-retry">Try again</Link>
        </div>
      </div>
    </div>
  );
}
